import { printAST } from '../core.print-ast.js';
import { xml2ast } from '../xml2ast/core.xml2ast.js';
import { allHtmlParsers } from '../xml2ast/parsers/common.html.js';
import { htmlNodeToJsxPrinter } from './common.html.js';
export { convertHtmlAttributesToReactProps, convertStyleAttributeToCssProps, guardStyles, makeHtmlNodeToJsxPrinter, printChildren } from './common.html.js';
import { textNodeToJsxPrinter } from './common.text.js';
export { allowedAttributeMap, coreAttrs, linkAttrs } from './common.html.attribute-map.js';

const basePrinters = {
  html: htmlNodeToJsxPrinter,
  text: textNodeToJsxPrinter
};
function printHtmlNodesToJsx(ast) {
  return printAST(ast, basePrinters);
}
function printHtmlToJsx(html, parsers = allHtmlParsers) {
  return printHtmlNodesToJsx(xml2ast(html, parsers, "text/html"));
}

export { htmlNodeToJsxPrinter, printHtmlNodesToJsx, printHtmlToJsx, textNodeToJsxPrinter };
//# sourceMappingURL=index.js.map
